import { HorizonJs_Url } from "./Url";
import { Jwt } from "horizon-js-sdk/lib/Jwt";
var AuthenticationManager = /** @class */ (function () {
    function AuthenticationManager() {
    }
    AuthenticationManager.isConnected = function () {
        return (window.localStorage.getItem(this.STORAGE_KEY_OAUTH_TOKEN) !== null &&
            window.localStorage.getItem(this.STORAGE_KEY_OAUTH_EXPIRES_AT) !== null &&
            parseInt('' + window.localStorage.getItem(this.STORAGE_KEY_OAUTH_EXPIRES_AT)) > (new Date()).getTime());
    };
    AuthenticationManager.connect = function (config) {
        var at = config.accessToken ? config.accessToken : HorizonJs_Url.getSearchParametersWithName('access_token');
        if (at !== null) {
            var state = config.state !== undefined ? config.state : HorizonJs_Url.getSearchParametersInHashbang()['state'];
            if (state == null) {
                state = HorizonJs_Url.getSearchParametersWithName("state");
            }
            var accessToken = at;
            var expireIn = config.expireIn !== undefined ? config.expireIn : parseInt('' + HorizonJs_Url.getSearchParametersWithName('expires_in'));
            var tokenType = config.token_type !== undefined ? config.token_type : HorizonJs_Url.getSearchParametersWithName('token_type');
            var expireAt = 0;
            if (window.localStorage.getItem(this.STORAGE_KEY_LOGGED_AT) !== null) {
                expireAt = expireIn * 1000 + parseInt('' + window.localStorage.getItem(this.STORAGE_KEY_LOGGED_AT));
            }
            if (window.localStorage.getItem(this.STORAGE_KEY_OAUTH_STATE) === state && expireAt !== 0) {
                window.localStorage.setItem(this.STORAGE_KEY_OAUTH_TOKEN, tokenType + ' ' + accessToken);
                window.localStorage.setItem(this.STORAGE_KEY_OAUTH_EXPIRES_AT, expireAt.toString());
                window.localStorage.removeItem('prefill_identifier');
                return true;
            }
            else {
                console.log('mismatch state');
                window.location.href = AuthenticationManager.removeParam('access_token', window.location.href);
                return false;
            }
        }
        //Regarde s'il n'est pas connecté
        if (!AuthenticationManager.isConnected()) {
            var state = this.generate_state(true);
            var prefillIdentifier = window.localStorage.getItem('prefill_identifier');
            var currentDate = (new Date()).getTime();
            window.localStorage.setItem(this.STORAGE_KEY_LOGGED_AT, currentDate.toString());
            var uriOauth_1 = config.authEndpoint + '?'
                + 'response_type=token'
                + '&state=' + state
                + '&client_id=' + config.clientId
                + '&redirect_uri=' + encodeURIComponent(config.returnUrl)
                + (prefillIdentifier ? ('&prefill_identifier=' + prefillIdentifier) : '');
            setTimeout(function () {
                window.location.replace(uriOauth_1);
            }, 500);
            return false;
        }
        return false;
    };
    AuthenticationManager.getAuthentificationHeader = function () {
        if (AuthenticationManager.isConnected()) {
            return window.localStorage.getItem(this.STORAGE_KEY_OAUTH_TOKEN);
        }
        else {
            return null;
        }
    };
    AuthenticationManager.getUserUid = function () {
        var oauthToken = window.localStorage.getItem(this.STORAGE_KEY_OAUTH_TOKEN);
        if (oauthToken !== null) {
            return Jwt.parseJwt(oauthToken).userId;
        }
        else {
            return '';
        }
    };
    AuthenticationManager.generate_state = function (setInLocalSotrage) {
        if (setInLocalSotrage === void 0) { setInLocalSotrage = true; }
        var state = '' + Math.random();
        if (setInLocalSotrage) {
            window.localStorage.setItem(this.STORAGE_KEY_OAUTH_STATE, state);
        }
        return state;
    };
    AuthenticationManager.disconnect = function (identityGatewayUrl, returnUrl) {
        if (returnUrl === void 0) { returnUrl = null; }
        localStorage.removeItem('oauth-state');
        localStorage.removeItem('logged_at');
        localStorage.removeItem('oauth-token');
        localStorage.removeItem('oauth-expires_at');
        localStorage.removeItem('oauth-redirectAfter');
        window.location.href = identityGatewayUrl + 'v1/oauth2/logout?returnUrl='
            + encodeURIComponent(returnUrl ? returnUrl : '');
    };
    AuthenticationManager.removeParam = function (key, sourceURL) {
        var rtn = sourceURL.split("?")[0], param, params_arr = [], queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
        if (queryString !== "") {
            params_arr = queryString.split("&");
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split("=")[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            if (params_arr.length)
                rtn = rtn + "?" + params_arr.join("&");
        }
        return rtn;
    };
    AuthenticationManager.STORAGE_KEY_OAUTH_TOKEN = 'oauth-token';
    AuthenticationManager.STORAGE_KEY_OAUTH_EXPIRES_AT = 'oauth-expires_at';
    AuthenticationManager.STORAGE_KEY_OAUTH_STATE = 'oauth-state';
    AuthenticationManager.STORAGE_KEY_LOGGED_AT = 'logged_at';
    return AuthenticationManager;
}());
export default AuthenticationManager;
//# sourceMappingURL=AuthenticationManager.js.map